import React from 'react'
import { Box, styled, Typography } from '@mui/material'


const StyledTypography = styled(Typography)(({theme}) => ({
    width: '100%',
    fontSize: '0.9rem',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    }
  }))


function itemssCard({...items}) {

  // const example_industries = items.example_industries;
    
  //   console.log('This is array',example_industries);
    

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2, alignItems: 'center' }} >
        <Box sx={{ width: '100%', height: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <Typography fontFamily={'sans-serif'} fontWeight={600} sx={{ width: '100%', fontSize: '1.1rem', textAlign: 'center' }} >{items.category}</Typography>
        </Box>      
        <Box sx={{ width: '100%', height: '80%', gap: 1, display: 'flex', flexDirection: 'column', alignItems: 'start' }} >
            <Typography fontFamily={'sans-serif'} sx={{ width: '100%', fontSize: '0.9rem', textAlign: 'center' }} >
                {items.description}
            </Typography>
            <StyledTypography fontFamily={'sans-serif'} >
                <b>Example sectors : </b> 
                {items.example_industries
                    ? items.example_industries.join(', ')
                    : items.example_sectors
                    ? items.example_sectors.join(', ')
                    : ''}
            </StyledTypography>
        </Box>      
    </Box>
  )
}

export default itemssCard
